import styled from '@emotion/styled';
import { ErrorMessage } from 'formik';

import { ICustomTheme } from 'interfaces';

export const InputContainer = styled.div<{ theme: ICustomTheme }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => `${theme.spacing(2)}px`};
`;

export const TitleContainer = styled.div<{ theme: ICustomTheme }>`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => `${theme.spacing(1)}px`};
`;

export const StyledErrorMessage = styled(ErrorMessage)<{ theme: ICustomTheme }>`
  color: ${({ theme }) => `${theme.colors.error.main}`};
  line-height: ${({ theme }) => theme.typography.h1.lineHeight};
  margin-top: ${({ theme }) => `${theme.spacing(1)}px`};
`;

export const StyledErrorMessageContainer = styled.div<{ theme: ICustomTheme }>`
  min-height: ${({ theme }) => theme.spacing(2)}px;
`;
